<template>
  <component-wrapper v-if="!isAppView">
    <fixperience-header-fi
      class="fixperience-page-header-fi"
      :logo-header="logoHeader"
      :home-data="homeData"
    />
  </component-wrapper>
</template>

<script setup lang="ts">
import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import FixperienceHeaderFi from '@/components/fixperience/fixperience-header-fi/FixperienceHeaderFi.vue';
import { useHeaderPage } from '@/components/header-fi/headerPage';

defineOptions({
  name: 'FixperiencePageHeaderFi',
});

const props = withDefaults(
  defineProps<{
    fields?: any;
    customData?: any;
  }>(),
  {
    fields: () => ({}),
    customData: () => null,
  },
);

const { logoHeader, homeData } = useHeaderPage(props);
</script>

<style scoped src="./fixperience-page-header-fi" />
